<template>
  <div>
    <div class="mdgridviewpage-bg mainWrap-bg applicationListPage">
      <div class="container-fluid maindivWrap pt-4">
        <div class="row">
          <div class="col-12">
            <div class="row mx-0">
                <div class="col-sm-4">
                  <div v-if="allRequestsList.length > 0">
                    <form>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fa fa-search" aria-hidden="true"></i>
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Search..."
                          id
                          name
                          v-model="searchName"
                          style="border-left:0;"
                        />
                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="d-flex" style="justify-content: flex-end;">
                  <div class="mx-2">
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="5"
                      label-cols-lg="5"
                      label="Show"
                      label-for="input-horizontal"
                      class="text-rightmr-5"
                    >
                      <b-form-select
                        v-model="perPage"
                        :options="options"
                        size="sm"
                        class
                        label="Show"
                        id="input-horizontal"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                </div>
                </div>
            </div>
          </div>
          <div class="col-12">
            <div id="tableview" class="mt-3">
              <table
                class="table table-striped table-hover table-responsive-sm bg-white"
                style="border: 1px solid #f0f0f0; border-radius: 10px; box-shadow: 0px 0px 2px #ddd;border-bottom: 0;"
              >
                <thead class="text-white" style="background:#273649;">
                  <tr>
                    <th class="text-white" style="border-top-left-radius: 10px; border-top:0;">Name</th>
                    <th class="text-white">Email</th>
                    <th class="text-white">Approved By</th>
                    <th class="text-white">User Role</th>
                    <th class="text-white">Requested Location</th>
                    <th class="text-white">Approved Location</th>
                    <th class="text-white">Status</th>
                    <th class="text-white" style="border-top-right-radius: 10px;  border-top:0;">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="allRequestsList.length > 0">
                    <template v-if="requestsList.length > 0">
                      <tr v-for="(request, requestInd) in requestsList" :key="requestInd">
                        <td>{{ request.firstName }} {{ request.lastName }}</td>
                        <td>{{ request.email }}</td>
                        <td>{{ request.approvedBy }}</td>
                        <td>{{ getRoleName(request.userRole) }}</td>
                        <td>{{ request.comment }}</td>
                        <td>{{ getLocationName(request.orgUid) }}</td>
                        <td>{{ request.status }}</td>
                        <td>
                          <div class="iconGroup text-center">
                            <a href="#manageRequest" @click="editRequest(request.email)">
                              <i class="fa fa-pencil-square-o cursor-pointer" aria-hidden="true" v-b-tooltip.hover title="Edit" ></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="8" class="text-center">No Requests Found!</td>
                      </tr>
                    </template>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="8" class="text-center">No Requests Found!</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <div class="mt-3" v-if="requestsList.length > 0">
              <b-pagination
              v-model="currentPage"
              :total-rows="allRequestsListLen"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              align="center"
              ></b-pagination>
            </div>
          </div>
          <div class="col-12" v-if="showRequestForm" id="manageRequest">
            <div class="wizardCard mb-4">
              <div class="card shadow-sm">
                <div class="card-header">Edit Request</div>
                <div class="card-body">
                  <div class="row m-0 mb-3">
                    <label for="indicatorName" class="col-sm-3 col-form-label">Name</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" id="indicatorName" placeholder v-model="requestForm.firstName+' '+requestForm.lastName" disabled/>
                    </div>
                  </div>
                  <div class="row m-0 mb-3">
                    <label for="indicatorDesc" class="col-sm-3 col-form-label" >Email</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" id="indicatorDesc" placeholder v-model="requestForm.email" disabled/>
                    </div>
                  </div>
                  <div class="row m-0 mb-3">
                    <label for="indicatorTypeName" class="col-sm-3 col-form-label" >User Role</label>
                      <div class="col-sm-9">
                        <div class="">
                          <select class="form-control" id="country" name="country" v-model="requestForm.userRole">
                            <option value="" disabled>Select User Role</option>
                            <option v-for="r in userRoles" :key="r.id" :value="r.id">{{r.displayName}}</option>
                          </select>
                        </div>
                      </div>
                  </div>

                  <div class="row m-0 mb-3">
                    <label for="indicatorTypeName" class="col-sm-3 col-form-label" >Location</label>
                      <div class="col-sm-9">
                        <div class="">
                          <treeselect :options="locationList" v-model="selectedLocation" placeholder="Search..." :show-count="true" :default-expand-level="defaultExpandLevel"/>
                        </div>
                      </div>
                  </div>

                  <div class="row m-0 mb-3">
                    <label for="indicatorTypeName" class="col-sm-3 col-form-label" >Applications</label>
                      <div class="col-sm-9">
                        <div class="">
                          <treeselect :options="allAppsList" v-model="selectedApplication" :multiple="true" placeholder="Search..." :show-count="true" :default-expand-level="defaultExpandLevel"/>
                        </div>
                      </div>
                  </div>

                  <div class="row m-0 mb-3">
                    <label for="indicatorTypeName" class="col-sm-3 col-form-label" >Status</label>
                      <div class="col-sm-9">
                        <div class="">
                          <select class="form-control" id="country" name="country" v-model="requestForm.status">
                            <option value="" disabled>Select Status</option>
                            <option v-for="s in statusList" :key="s.id" :value="s.id">{{s.displayName}}</option>
                          </select>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="showRequestForm">
            <div class="bottomSubmitbtn float-right mb-4">
              <button class="btn btn-newprimary" @click="updateRequest" :disabled="!selectedLocation || selectedApplication.length === 0 || requestForm.status.toLowerCase() === 'incomplete'">
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import ApiServices from '../service/ApiServices';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  components: {
    Treeselect
  },
  data() {
    return {
      allRequestsList: [],
      currentPage: 1,
      perPage: 10,
      searchName: "",
      allRequestsListLen: 0,
      options: [
        { value: "10", text: "10" },
        { value: "50", text: "50" },
        { value: "100", text: "100" },
        { value: "500", text: "500" }
      ],
      showRequestForm: false,
      requestForm: null,
      userRoles: [],
      locationList: [],
      statusList: [
        {id: 'Approved', displayName: 'Approve'},
        {id: 'Rejected', displayName: 'Reject'}
      ],
      selectedLocation: null,
      defaultExpandLevel: 1,
      flatLocationList: [],
      allAppsList: [],
      selectedApplication: [],
      userStatus: ""
    }
  },
  computed: {
    requestsList() {
      let filteredRequests = this.allRequestsList.filter(
        a =>
          (a.firstName && a.firstName.toLowerCase().includes(this.searchName.toLowerCase())) ||
          (a.lastName && a.lastName.toLowerCase().includes(this.searchName.toLowerCase()))
      )
      // console.log("filteredRequests",filteredRequests)
      this.allRequestsListLen = filteredRequests.length
      return filteredRequests.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    }
  },
  methods: {
    getUserRoles() {
      this.$root.loading = true
      ApiServices.RestGetCall('api/userRoles?fields=displayName%2Cid%2C&order=name%3Aasc').then(response => {
        // console.log("user roles", response)
        this.userRoles = response.userRoles
      }).then( () => {
        let uid = JSON.parse(localStorage.getItem('userProfile')).orguid
        ApiServices.getOrganisationChildren(uid, 1).then(response => {
          // console.log("user location list", response)
          let locList = this.renameKeys(response.data)
          this.locationList = [locList]
        }).then( () => {
          this.getAllApps()
        }).catch( () => {
          console.log("Failed to get Organisation Childrens...")
        })
      }).catch( () => {
        console.log("Failed to get User Roles...")
      })
    },
    flattenLoctionList(array) {
      var result = [];
      array.forEach((a) => {
        result.push(a);
        if (Array.isArray(a.children)) {
          let children = a.children.map(c => ({
            ...c,
            parentID: a.id
          }))
          result = result.concat(this.flattenLoctionList(children));
        }
      });
      return result;
    },
    getAllApps() {
      ApiServices.getAllKeys().then(async response => {
        console.log(response)
        let filteredApps = []

        response.data.forEach(a => {
          let keyName = a.split("_");
          if (a.includes("applicationModule") && keyName.includes("en")) {
            filteredApps.push(a);
          }
        });

        await ApiServices.RestGetCall("/api/avenir/training/getTrainingApps").then(response => {
          console.log("Training response", response.trainingApp)
          let traningApps = response.trainingApp
          if(!Array.isArray(traningApps)) {
            traningApps = traningApps.replace(/'/g, '"');
            traningApps = JSON.parse(traningApps);
          }
          if(traningApps.length > 0) {
            traningApps.forEach(t => {
              this.allAppsList.push({id: t.appId, label: t.appName})
            })
          }
        })
        if(filteredApps.length) {
          filteredApps.forEach(async (f,i) => {
            let appResponse = await ApiServices.getSavedConfig(f)
            this.allAppsList.push({id: appResponse.data.appId, label: appResponse.data.appName})
          })
        }
      }).then( () => {
        this.getRequests()
      }).catch(res => (this.$root.loading = false));
    },
    getLocationName(locationID) {
      let locationList = this.flattenLoctionList(this.locationList)
      let locationObj = locationList.find( l => l.id === locationID)
      let locationName = locationID
      if(locationObj) {
        locationName = locationObj.label
      }
      return locationName
    },
    renameKeys(obj) {
      const keyValues = Object.keys(obj).map(key => {

        let newKey = null,
          level = null,
          id = null

        if (key === 'displayName') {
          newKey = 'label'
        } else {
          newKey = key
        }
        if (key === 'children') {
          obj[key] = obj[key].map(obj => this.renameKeys(obj)).sort((a, b) => a.label > b.label ? 1 : a.label < b.label ? -1 : 0);
        }
        return {
          [newKey]: key === 'id' ? obj.id : obj[key]
        };
      }).sort((a, b) => a.displayName > b.displayName ? 1 : a.displayName < b.displayName ? -1 : 0);
      return Object.assign({}, ...keyValues);
    },
    getRequests(){
      ApiServices.RestGetCall('api/avenir/register/getUserRequests ').then(response => {
        // console.log("user requests", response)
        this.allRequestsList = response.requests
        this.$root.loading = false
      })
    },
    editRequest(email) {
      console.log(email)
      let form = this.allRequestsList.find(r => r.email === email)
      if(form) {
        this.requestForm = form
        this.userStatus = form.status
        this.selectedLocation = form.orgUid ? form.orgUid : null
        this.selectedApplication = form.appIds ? form.appIds : []
        this.showRequestForm = true
      }
    },
    updateRequest() {
      this.$root.loading = true
      let request = {
        email: this.requestForm.email,
        userRole: this.requestForm.userRole,
        orgUid: this.selectedLocation,
        appIds: JSON.stringify(this.selectedApplication),
        status: this.requestForm.status,
        isApproved: this.userStatus.toLowerCase() === 'approved' ? true : false
      }
      ApiServices.RestPostCall('api/avenir/register/manageRequest', request).then(response => {
        // console.log("manage requests", response)
        this.showRequestForm = false
        this.$swal({
          text: response.message
        })
        this.getRequests()
      }).catch(() => {
        this.$root.loading = false
      })
    },
    getRoleName(roleId) {
      // console.log('roleId',roleId)
      return roleId ? this.userRoles.find(r => r.id === roleId).displayName : ""
    }
  },
  mounted() {
    this.getUserRoles()
  }
}
</script>
<style lang="scss" scoped>

</style>
